import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { ROUTES } from 'shared/constants/routes';

const APP_NAME = 'Marcô';
const DEFAULT_TITLE = 'Marcô | Quadras, aulas e jogos em um só lugar';

// Título da aba por tela: com várias abas abertas na apresentação, cada uma se identifica.
const PAGE_TITLES: [string, string][] = [
  [ROUTES.LOGIN, 'Entrar'],
  [ROUTES.SIGNUP, 'Criar conta'],
  [ROUTES.PROFILE, 'Meu perfil'],
  [ROUTES.MY_AGENDA, 'Minha agenda'],
  [ROUTES.CHECKOUT, 'Pagamento'],
  [ROUTES.BOOKING, 'Reservar quadra'],
  [ROUTES.CLASSES, 'Aulas'],
  [ROUTES.TOURNAMENT_DETAIL, 'Torneio'],
  [ROUTES.TOURNAMENTS, 'Torneios'],
  [ROUTES.MURAL, 'Mural'],
  [ROUTES.ARENA_ONBOARDING, 'Cadastrar arena'],
  [ROUTES.ARENA_DASHBOARD, 'Agenda da arena'],
  [ROUTES.ARENA_RESERVATIONS, 'Reservas'],
  [ROUTES.ARENA_CLASSES, 'Aulas e turmas'],
  [ROUTES.ARENA_TOURNAMENTS, 'Torneios da arena'],
  [ROUTES.ARENA_MURAL, 'Mural da arena'],
  [ROUTES.ARENA_SUBSCRIPTIONS, 'Assinaturas'],
  [ROUTES.ARENA_SETTINGS, 'Quadras e equipe'],
  [ROUTES.ARENA_REPORTS, 'Relatórios'],
  [ROUTES.ADMIN_DASHBOARD, 'Administração'],
  [ROUTES.INSTRUCTOR_CLASSES, 'Minhas turmas'],
  [ROUTES.RECEPCAO_RESERVATIONS, 'Recepção'],
];

export function usePageTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    const match = PAGE_TITLES.find(([pattern]) => matchPath(pattern, pathname));
    document.title = match ? `${match[1]} · ${APP_NAME}` : DEFAULT_TITLE;
  }, [pathname]);
}
